import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface ActivityPayload {
  txHash: string;
  chainId: number | string;
  actionType: string;
  status?: string;
  payload?: any;
  platformName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  private http = inject(HttpClient);

  recordActivity(data: ActivityPayload) {
    const url = `${environment.apiUrl}/user/activity/record`;
    // Fire and forget usually, but returning observable
    return this.http.post(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`
      }
    });
  }
}
